import type { ListNode } from '~/client/src/shared/lists/core'

export function recordIdsBetween<T>(
  nodes: readonly ListNode<T>[],
  anchorId: string | null | undefined,
  targetId: string,
): readonly string[] {
  if (!anchorId) return [targetId]

  const recordIds = nodes.flatMap(node =>
    node.kind === 'record' ? [node.recordId] : [],
  )
  const anchorIndex = recordIds.indexOf(anchorId)
  const targetIndex = recordIds.indexOf(targetId)

  if (anchorIndex === -1 || targetIndex === -1) return [targetId]

  const start = Math.min(anchorIndex, targetIndex)
  const end = Math.max(anchorIndex, targetIndex)

  return recordIds.slice(start, end + 1)
}
